import axios from 'axios';

// Debug: Log the API URL configuration
console.log('🔍 REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('🔍 Full baseURL:', process.env.REACT_APP_API_URL || 'http://localhost:5000');

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
  timeout: 300000, // 5 minutes for longer operations like import
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api; 